export default "__VITE_ASSET__BuJmlmXm__"